export default __webpack_public_path__ + "static/media/open-new-tab.7124314d.svg";